import { render, staticRenderFns } from "./ModalDetailClassification.vue?vue&type=template&id=360d96dd"
import script from "./ModalDetailClassification.vue?vue&type=script&lang=js"
export * from "./ModalDetailClassification.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailClassification.vue?vue&type=style&index=0&id=360d96dd&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360d96dd')) {
      api.createRecord('360d96dd', component.options)
    } else {
      api.reload('360d96dd', component.options)
    }
    module.hot.accept("./ModalDetailClassification.vue?vue&type=template&id=360d96dd", function () {
      api.rerender('360d96dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/ModalDetailClassification.vue"
export default component.exports